/**
 * Les événements Amplitude d'un achat, sous les noms de l'ancien code.
 *
 * L'ancien écran poussait, après chaque achat, une file de félicitations (`MyPetalsTabScreen.js`) :
 * le geste financé, la quête de Tina, le nouveau titre quand l'achat en donne un, le partage. Chaque
 * écran se mesurait à son ouverture (`CongratsScreen.js` : `amplitude.track("congrats." + type)`,
 * sans propriété), et l'élève les passait tous (le retour était bloqué). L'accusé du nouvel espace
 * tient en une étape : il émet la même série, dans le même ordre, quand il s'ouvre.
 */
import { type ApiGameSkillSet } from "../../../../adapters/student/shared/questAdapter"
import { announcesNewTitle } from "../../../../adapters/student/Game/shopAdapter"

/** Les types de `congratsTypes` (`CongratsScreen.js`) que l'achat poussait. */
const CONGRATS = {
    purchased: "SHOP_PRODUCT_PURCHASED",
    progress: "MY_PROGRESS",
    newTitle: "NEW_TITLE_CONGRATS",
    share: "SHARE_STATS",
} as const

/** Les noms des événements d'un achat, dans l'ordre où l'ancien code les émettait. */
export function purchaseCongratsEvents(gesturesSkillSet: ApiGameSkillSet | null | undefined): string[] {
    const types: string[] = [CONGRATS.purchased, CONGRATS.progress]
    if (announcesNewTitle(gesturesSkillSet)) types.push(CONGRATS.newTitle)
    types.push(CONGRATS.share)
    return types.map((type) => `congrats.${type}`)
}
